import React, { useState } from 'react';
import { Box, IconButton, Modal, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import { Document, Page, pdfjs } from 'react-pdf';
import { FaFileAlt } from 'react-icons/fa';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ModalBox = styled(Box)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    boxShadow: '0px 12px 24px 0px #919EAB1F, 0px 0px 2px 0px #919EAB33',
    borderRadius: '8px',
    padding: '24px',
    width: "80%",
    height: "80%",
    maxWidth: "80%",
    maxHeight: "80%",
    overflowY: "auto"
});

// const DocumentViewer = ({ open, onClose, file }) => {
//     const renderDocumentContent = () => {
//         const fileType = file?.name.split('.').pop().toLowerCase();

//         switch (fileType) {
//             case 'pdf':
//                 return (
//                     <Document file={file.data}>
//                         <Page pageNumber={1} />
//                     </Document>
//                 );
//             case 'jpg':
//             case 'jpeg':
//             case 'png':
//                 return <img src={file.data} alt={file.name} style={{ maxWidth: '100%', maxHeight: '100%' }} />;
//             case 'doc':
//             case 'docx':
//             case 'xls':
//             case 'xlsx':
//             case 'ppt':
//             case 'pptx':
//             case 'txt':
//             case 'csv':
//                 return (
//                     <iframe
//                         src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file.data)}`}
//                         title={file.name}
//                         style={{ width: '100%', height: '100%' }}
//                     />
//                 );
//             case 'mp4':
//             case 'avi':
//             case 'mov':
//             case 'wmv':
//                 return (
//                     <video controls style={{ maxWidth: '100%', maxHeight: '100%' }}>
//                         <source src={file.data} type={`video/${fileType}`} />
//                         Your browser does not support the video tag.
//                     </video>
//                 );
//             default:
//                 return <iframe src={file.data} title={file.name} style={{ width: '100%', height: '100%' }} />;
//         }
//     };

const DocumentViewer = ({ open, onClose, file }) => {
    const isMobileScreen = useMediaQuery('(max-width:526px)');

    // console.log("File Information:", file);

    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const renderDocumentContent = () => {

        if (!file) {
            return <FaFileAlt style={{ color: 'gray', fontSize: '2em' }} />; // Default for undefined/null
        }

        const fileName = file?.name || file?.document_name; // Support both cases
        const fileType =file?.document_type|| fileName?.split('.').pop().toLowerCase();
        const fileUrl = file?.data || file?.document_url;
// console.log("File Type inside-----------",fileType);
        switch (fileType) {
            case 'jpg':
            case 'image/jpeg':
                 return <img src={fileUrl} alt={fileName} style={{ maxWidth: '100%', maxHeight: '100%' }} />;
            case 'png':
                return <img src={fileUrl} alt={fileName} style={{ maxWidth: '100%', maxHeight: '100%' }} />;
            case 'mp4':
            case 'avi':
            case 'mov':
            case 'wmv':
                return (
                    <video controls style={{ maxWidth: '100%', maxHeight: '100%' }}>
                        <source src={fileUrl} type={`video/${fileType}`} />
                        Your browser does not support the video tag.
                    </video>
                );
            case 'application/pdf':
                return (
                    <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess} renderMode="canvas">
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} />
                        ))}
                    </Document>
                );
            case 'docx': return (
                <iframe
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
                    style={{ width: '100%', height: '600px', border: 'none' }}
                    title={fileName}
                />
            );
            case 'msword':

            case 'doc':
            // case 'xlsx':
            case 'xlsx':
                return (
                    <iframe
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
                        style={{ width: '100%', height: '600px', border: 'none' }}
                        title={fileName}
                    />
                );
            case 'xls':
            case 'pptx':
            case 'ppt': {
                const fileMimeTypes = {
                    pdf: 'application/pdf',
                    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    doc: 'application/msword',
                    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    xls: 'application/vnd.ms-excel',
                    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    ppt: 'application/vnd.ms-powerpoint'
                };
                return (
                    <DocViewer
                        documents={[{
                            uri: file.data,
                            fileType: fileMimeTypes[fileType] || fileType // Pass MIME type explicitly 
                        }]}
                        pluginRenderers={DocViewerRenderers}
                        style={{ width: '100%', height: '92%' }}
                        config={{
                            header: {
                                disableHeader: true // This should hide the toolbar/header
                            }
                        }}
                    />

                );
            }
            default: {
                // Trigger download for unsupported formats
                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                onClose(); // Close modal after download starts
                return null; // Don't render anything for unsupported types
            }
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalBox sx={{ height: isMobileScreen ? "50%" : "80%" }}>
                <div className="modal-heading mb-4">
                    <h5><strong>Preview File {file?.name || file?.document_name}</strong></h5>
                    <span className='file-attach-icon-container'>
                        <IconButton color="rgb(0, 0, 0, 0.54)" onClick={onClose} disableTouchRipple>
                            <CloseRoundedIcon />
                        </IconButton>
                    </span>
                </div>
                <div className="document-viewer-content mx-auto" style={{ width: isMobileScreen ? "85%" : '100%', height: isMobileScreen ? "85%" : '100%' }}>
                    {renderDocumentContent()}
                </div>
            </ModalBox>
        </Modal>
    );
};

export default DocumentViewer;
